import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { ReactComponent as Coins } from '../../assets/coins.svg';
import { Container } from '../Container';
import { MenuItem, FormControl, Select } from '@mui/material';
import { useTypedTheme } from '@monorepo-web/styles';
export default function Instituicao({ options, initialOption, loadingOptions, disabled, handleSelect, floatLeft }) {
    const theme = useTypedTheme();
    const [option, setOption] = useState(initialOption);
    function MenuItemStyles() {
        return {
            backgroundColor: theme.dropSelectorColor,
            color: theme.backgroundColorSecondary,
            fontFamily: 'Roboto !important',
            marginTop: -8,
            marginBottom: -8,
        };
    }
    const handleChange = (event) => {
        const { target: { value }, } = event;
        setOption(value);
        handleSelect(value);
    };
    useEffect(() => {
        setOption(initialOption);
    }, [initialOption]);
    return (_jsx(Container, Object.assign({ floatLeft: floatLeft !== null && floatLeft !== void 0 ? floatLeft : false }, { children: _jsx(FormControl, Object.assign({ variant: "standard", style: { display: 'flex', flexDirection: 'row' } }, { children: _jsx(Select, Object.assign({ disabled: disabled, displayEmpty: true, value: option, onChange: handleChange, renderValue: (selected) => {
                    if (!selected) {
                        return (_jsx("div", Object.assign({ style: { color: theme.fontColor } }, { children: (loadingOptions && !disabled) ? 'Carregando...' : 'Instituição' })));
                    }
                    return options.filter((obj) => obj === selected)[0];
                }, inputProps: {
                    'aria-label': 'Without label',
                    IconComponent: () => _jsx(Coins, { width: "25px", fill: disabled ? theme.disabledColor : theme.iconsColor }),
                } }, { children: options.map((item) => (_jsx(MenuItem, Object.assign({ style: MenuItemStyles(), value: item }, { children: item }), item))) })) })) })));
}
